import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { resolveImageUrl } from '../lib/api';

interface ProductGalleryProps {
  images: string[];
  title: string;
}

export function ProductGallery({ images, title }: ProductGalleryProps) {
  const { t } = useTranslation();
  const [active, setActive] = useState(0);
  const safeImages = images.length > 0 ? images : [''];
  const current = safeImages[Math.min(active, safeImages.length - 1)];

  return (
    <div className="flex flex-col gap-4">
      <div className="relative aspect-[4/5] overflow-hidden bg-linen">
        <img
          src={resolveImageUrl(current)}
          alt={title}
          className="w-full h-full object-cover"
        />
      </div>
      {safeImages.length > 1 && (
        <div className="grid grid-cols-4 gap-2" role="tablist" aria-label={t('productDetail.gallery')}>
          {safeImages.map((src, idx) => {
            const isActive = idx === active;
            return (
              <button
                key={`${src}-${idx}`}
                type="button"
                role="tab"
                aria-selected={isActive}
                onClick={() => setActive(idx)}
                className={`relative aspect-square overflow-hidden bg-linen transition-opacity ${
                  isActive ? 'ring-2 ring-brass opacity-100' : 'opacity-70 hover:opacity-100'
                }`}
              >
                <img
                  src={resolveImageUrl(src)}
                  alt={t('productDetail.thumbnailAlt', { n: idx + 1, title })}
                  className="w-full h-full object-cover"
                />
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
